import { clsx } from "@mantine/core";

interface PublisherPillProps {
  publishedBy: string | null | undefined;
}

const PublisherPill = ({ publishedBy }: PublisherPillProps) => {
  return (
    <span
      className={clsx(
        "px-2 py-1 rounded-full text-sm font-medium",
        (publishedBy?.toLowerCase().includes("kek"))
          ? "bg-green-100 text-green-700"
          : (publishedBy?.toLowerCase().includes("visal"))
          ? "bg-blue-100 text-blue-700"
          : (publishedBy?.toLowerCase().includes("placeit"))
          ? "bg-purple-100 text-purple-700"
          : "text-gray-600"
      )}
    >
      {publishedBy || "N/A"}
    </span>
  );
};

export default PublisherPill;